
		<div *ngFor="let error of controlErrors">
			<ng-container [ngTemplateOutlet]="template"
						  [ngTemplateOutletContext]="{errorCode: error.code, errorData: error.data}"></ng-container>
		</div>
	